export default (number, culture = 'es-AR') => {
    var minimumFractionDigits=culture!='es-PY'?2:0;
    var maximumFractionDigits=culture!='es-PY'?2:0;
    if(!number) return;

    return number.toLocaleString(culture, { minimumFractionDigits: minimumFractionDigits, maximumFractionDigits: maximumFractionDigits });
}